import * as $ from "jquery";
import "../../lib/ion.rangeSlider.js";
import * as AudioTrack from "../modules/audio";

namespace PFF.controllers.innovations {

	//this if for the restore showerhead innovation page
	function initCustomSlider() {
		//if our target is not on the page return
		if(!$('.js-restore-slider').length) {
			return;
		}

		//this needs to be updated so the Object Fit polyfill for IE Versions works properly
		$('.v-innovations__frame-stack .hero-feature__bg').data('object-position', 'top right');



		let $fullCoverageImg = '//images.pfisterfaucets.com/is/image/Pfister/bg-settings-full-coverage2?$pfFullWidthCoverImage$&fit=constrain';
		let $messageImg = '//images.pfisterfaucets.com/is/image/Pfister/bg-settings-massage?$pfFullWidthCoverImage$&fit=constrain';

		/*
		let imagesToCache = [
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-full-coverage2?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-message?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore1?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore2?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore3?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore4?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore5?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore6?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore7?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore8?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore9?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore10?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore11?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore12?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore13?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore14?$pfFullWidthCoverImage$&fit=constrain',
			'//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore15?$pfFullWidthCoverImage$&fit=constrain',
		];
		let preloadedImgs = [];
		let frameStackImgsLength = imagesToCache.length;
		let i;

		// here were pushing up the imagesToCache array and caching them so they can be ready for use quicker
		for (i = 0; i < frameStackImgsLength; i++) {
			let img = new Image();
			img.src = imagesToCache[i];
			if(img.src) {
				preloadedImgs.push(img);
			}
		}
		*/

		//setup the Range Slider
		$('.js-restore-slider').ionRangeSlider({
			type: "single",
			grid: false,
			hide_from_to: true,
			hide_min_max: true,
			min: 1,
			max: 15,
			from: 1,
		});

		let $restoreSlider = $('.js-restore-slider').data("ionRangeSlider");
		let $restoreSliderElem = $('.js-restore-slider');
		let $originalSrc = $restoreSliderElem.parents('.hero-feature').find('.hero-feature__bg').attr('src');

		// console.log($restoreSlider);

		$('.v-innovations__frame-stack .hero-feature__bg').removeAttr('srcset');

		//Need to change the image on tab click so setting src attributes for each tab
		$('.v-innovations__frame-stack .js-tab').on('click', function(e){
			var $this = $(this);
			var $id = e.target.id;
			var $parent = $this.parents('.v-innovations__frame-stack');


			if( $id == "toggle-full-coverage" ) {
				$parent.find('.hero-feature__bg').attr('src', $fullCoverageImg);
			} else if ( $id == "toggle-massage" ) {
				$parent.find('.hero-feature__bg').attr('src', $messageImg);
			}  else if ( $id == "toggle-restore" ) {
				$parent.find('.hero-feature__bg').attr('src', $originalSrc);
				$restoreSlider.options.from = 1;
				$restoreSlider.reset();
			}

			// console.log($restoreSlider.options.from);

			e.preventDefault();
		});

		//setting up the change event on the range slider to cycle through each image in the settings array as it slides
		$restoreSliderElem.on("change", function () {
			var $this = $(this),
				$defaultSize = $this.data('default'),
				$wideSize = $this.data('wide'),
				$parent = $this.parents('.hero-feature'),
				$value = $this.prop("value");

				switch($value) {
					case "1":
						var $imgSrc = $originalSrc;
						break;
					case $value:
						var $imgSrc = '//images.pfisterfaucets.com/is/image/Pfister/bg-settings-restore'+$value+'?$pfFullWidthCoverImage$&fit=constrain';
						break;
					default:
						var $imgSrc = $originalSrc;
				}


			$parent.find('.hero-feature__bg').attr('src', $imgSrc);
			//console.log($imgSrc);
		});
	}


	export function init() {
		AudioTrack.init();
		initCustomSlider();
	}
}

PFF.controllers.innovations.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/innovations.ts